import { useState, useCallback, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import LoaderContext from './context';
import { setLoaderCallbacks } from 'utils/loaderManager';

export function LoaderProvider({ children }) {
  const [pendingRequests, setPendingRequests] = useState(0);

  const incrementRequests = useCallback(() => {
    setPendingRequests((prev) => prev + 1);
  }, []);

  const decrementRequests = useCallback(() => {
    setPendingRequests((prev) => Math.max(0, prev - 1));
  }, []);

  // Register callbacks with the loader manager for axios interceptors
  useEffect(() => {
    setLoaderCallbacks(incrementRequests, decrementRequests);
  }, [incrementRequests, decrementRequests]);

  const value = useMemo(
    () => ({
      isLoading: pendingRequests > 0,
      pendingRequests,
      incrementRequests,
      decrementRequests,
    }),
    [pendingRequests, incrementRequests, decrementRequests]
  );

  return <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>;
}

LoaderProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
